function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { closeEditor, updateCellValue } from 'ka-table/actionCreators';
import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
var CustomEditor = function CustomEditor(_ref) {
  var column = _ref.column,
    rowKeyValue = _ref.rowKeyValue,
    dispatch = _ref.dispatch,
    value = _ref.value;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    editorValue = _useState2[0],
    setValue = _useState2[1];
  var _useSnackbar = useSnackbar(),
    enqueueSnackbar = _useSnackbar.enqueueSnackbar;
  var handleChange = function handleChange(e) {
    var newValue = e.currentTarget.value;
    setValue(newValue);
    if (!newValue) {
      enqueueSnackbar('This field cannot be empty', {
        variant: 'error'
      });
      return;
    }
    dispatch(updateCellValue(rowKeyValue, column.key, newValue));
  };
  useEffect(function () {
    setValue(value);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "custom-editor"
  }, /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    style: {
      resize: 'none'
    },
    rows: "4",
    value: editorValue,
    onChange: handleChange
  }));
};
export default CustomEditor;